export default __webpack_public_path__ + "static/media/busd.96520134.svg";